(() => {
  function updateMinusButtonState(quantityRoot) {
    const input = quantityRoot.querySelector(".quantity__input");
    const minusButton = quantityRoot.querySelector('button[name="minus"]');
    if (!input || !minusButton) return;

    const value = parseInt(input.value, 10) || 0;
    minusButton.classList.toggle("active_minus", value > 0);
  }

  function initQuantityControls(scope) {
    scope.querySelectorAll(".replacement_quantity").forEach((quantityRoot) => {
      const input = quantityRoot.querySelector(".quantity__input");
      const plusButton = quantityRoot.querySelector('button[name="plus"]');
      const minusButton = quantityRoot.querySelector('button[name="minus"]');
      if (!input || !plusButton || !minusButton) return;

      const sync = () => updateMinusButtonState(quantityRoot);
      plusButton.addEventListener("click", sync);
      minusButton.addEventListener("click", sync);
      input.addEventListener("input", sync);
      sync();
    });
  }

  function initInfoToggles(scope) {
    scope.querySelectorAll(".replacement_part_info_button").forEach((button) => {
      button.addEventListener("click", () => {
        const infoDiv = button.closest(".replacement_part_info");
        if (!infoDiv) return;
        infoDiv.classList.toggle("show_pdp_info");
      });
    });
  }

  function initCustomScrollbar(scope) {
    const container = scope.querySelector(".replacement_parts_wrapper");
    const content = scope.querySelector(".configurator-form");
    const scrollbar = scope.querySelector(".custom-scroller");
    const scrollbarThumb = scope.querySelector(".custom-scroll");

    if (!container || !content || !scrollbar || !scrollbarThumb) return;

    const updateScrollbar = () => {
      const contentHeight = container.scrollHeight;
      const containerHeight = container.clientHeight;

      if (!contentHeight || contentHeight <= containerHeight) {
        scrollbar.style.visibility = "hidden";
        scrollbarThumb.style.transform = "translateY(0)";
        return;
      }

      scrollbar.style.visibility = "visible";
      const scrollRatio = containerHeight / contentHeight;
      scrollbarThumb.style.height = `${Math.max(10, scrollRatio * 100)}%`;

      const maxContainerScroll = contentHeight - containerHeight;
      const trackHeight = containerHeight - scrollbarThumb.offsetHeight;
      const scrollProgress = maxContainerScroll > 0 ? container.scrollTop / maxContainerScroll : 0;
      scrollbarThumb.style.transform = `translateY(${Math.max(0, trackHeight * scrollProgress)}px)`;
    };

    container.addEventListener("scroll", updateScrollbar);

    scrollbarThumb.addEventListener("mousedown", (event) => {
      event.preventDefault();
      const startY = event.clientY;
      const startScrollTop = container.scrollTop;

      const onMouseMove = (moveEvent) => {
        const deltaY = moveEvent.clientY - startY;
        const ratio = container.scrollHeight / container.clientHeight;
        container.scrollTop = startScrollTop + deltaY * ratio;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });

    updateScrollbar();
    window.addEventListener("resize", updateScrollbar);
  }

  function initAddToCartForm(form) {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const submitButton = form.querySelector("#submit-button");
      if (submitButton && submitButton.getAttribute("aria-disabled") === "true") return;

      const inputs = form.querySelectorAll(".replacement_quantity .quantity__input");
      const message = form.querySelector(".replacement-parts-message");
      const items = [];

      inputs.forEach((input) => {
        const quantity = parseInt(input.value, 10) || 0;
        const productId = parseInt(input.getAttribute("product-id"), 10);
        if (quantity > 0 && Number.isFinite(productId)) {
          items.push({ id: productId, quantity });
        }
      });

      if (!items.length) {
        if (message) message.style.display = "block";
        return;
      }
      if (message) message.style.display = "none";

      if (submitButton) {
        submitButton.setAttribute("aria-disabled", "true");
        submitButton.classList.add("loading");
      }

      const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      const products = { items };
      let body = JSON.stringify(products);

      if (cart) {
        body = JSON.stringify({
          ...products,
          sections_url: window.location.pathname
        });
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(document.activeElement);
        }
      }

      try {
        const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body });
        const responseData = await response.json();
        if (responseData.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: form,
            errors: responseData.errors || responseData.description,
            message: responseData.message
          });
          console.error("Error adding item to cart:", responseData.description || responseData.message);
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: form,
          cartData: responseData,
          type: "bundle"
        });

        if (cart.nodeName === "CART-DRAWER") {
          document.body.addEventListener(
            "cartRendered",
            () => {
              setTimeout(() => cart.open());
            },
            { once: true }
          );
        } else if (cart.nodeName === "CART-NOTIFICATION") {
          const drawer = document.querySelector("cart-drawer");
          if (drawer) {
            document.body.addEventListener(
              "cartRendered",
              () => {
                setTimeout(() => drawer.open());
              },
              { once: true }
            );
          } else {
            document.body.addEventListener(
              "cartNotificationRendered",
              () => {
                setTimeout(() => cart.show());
              },
              { once: true }
            );
          }
        }
      } catch (error) {
        console.error("Error adding item to cart:", error);
      } finally {
        if (submitButton) {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
        }
      }
    });
  }

  function initAccordion(scope) {
    scope.querySelectorAll(".PdpHero-content_accordion_title").forEach((title) => {
      title.addEventListener("click", () => {
        const accordion = title.closest(".PdpHero-content_accordion");
        if (!accordion) return;
        accordion.classList.toggle("PdpHero-content_accordion--active");
      });
    });
  }

  function initReplacementHero() {
    const forms = document.querySelectorAll(".configurator-form");
    forms.forEach((form) => {
      const root = form.closest(".replacement_parts_right") || form.parentElement || document;
      initAddToCartForm(form);
      initQuantityControls(root);
      initInfoToggles(root);
      initCustomScrollbar(root);
      initAccordion(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReplacementHero);
  } else {
    initReplacementHero();
  }
})();
